import { combineReducers } from 'redux';
import { appSettings, event, objects, players, race } from './slices';

const appReducer = combineReducers({ appSettings, event, race, objects, players });

export default appReducer;
